import { config } from '#core/config/env';
import axios from 'axios';

// Paths that avoid redirection to forbidden page on a 403 error
const forbiddenExclusions = ['/forbidden', '/monitoring'];

const ApiClient = axios.create({
  baseURL: config.apiBaseUrl,
  timeout: 30 * 1000,
  headers: {
    'Content-Type': 'application/json'
  },
  withCredentials: true
});

ApiClient.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    if (error.response.status === 403 && forbiddenExclusions.includes(location.href)) {
      location.href = `/forbidden`;
    }

    if (error.response.status === 401 || error.response.data.error === 'UNAUTHORIZED') {
      location.href = `${window.location.origin}${config.apiBaseUrl}${config.apiLoginPath}`;
    }

    return Promise.reject(error);
  }
);

export default ApiClient;
